// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"certificate_wrapper__vgtt8"};